module.exports = __webpack_public_path__ + "img/portrait-049.e1ed5ca5.jpg";